import { Pipe, PipeTransform, Inject } from '@angular/core';
import { BringozWeightPipe } from './bringoz-weight.pipe';

@Pipe({
  standalone: false,
  name: 'packageWeight'
})
export class PackageWeightPipe implements PipeTransform {

  constructor(
    @Inject('splitService') private splitService,
    @Inject(BringozWeightPipe) private bringozWeightPipe: BringozWeightPipe
  ) {}

  transform(packageList: any[], enableUnitDisplay: boolean): string {
    let totalWeight = 0;
    let hasAnyWeight = false;

    if (Array.isArray(packageList) && packageList.length) {
      packageList.forEach(pkg => {
        if (pkg?.items?.length) {
          pkg.items.forEach(item => {
            if (item.weight !== undefined) {
              hasAnyWeight = true;
            }
            totalWeight += item.weight || 0;
          });
        }
      });
    }

    return hasAnyWeight
      ? this.bringozWeightPipe.transform(totalWeight, enableUnitDisplay)
      : '--';
  }
}





// import { Pipe, PipeTransform, Inject } from '@angular/core';
// import { BringozWeightPipe } from './bringoz-weight.pipe';
//
// @Pipe({
//     name: 'packageWeight'
// })
// export class PackageWeightPipe implements PipeTransform {
//
//     constructor(
//         @Inject('splitService') private splitService,
//         @Inject(BringozWeightPipe) private bringozWeightPipe: BringozWeightPipe
//     ) {}
//
//     transform(packageRef: any, enableUnitDisplay: boolean): string {
//         let itemsWeightSum = 0;
//         let hasAnyWeight = false;
//
//         if (packageRef && packageRef.items?.length) {
//             itemsWeightSum = packageRef.items.reduce((sum, item) => {
//                 if (item.weight !== undefined) {
//                     hasAnyWeight = true;
//                 }
//                 return sum + (item.weight || 0);
//             }, 0);
//         }
//
//         return hasAnyWeight
//             ? this.bringozWeightPipe.transform(itemsWeightSum, enableUnitDisplay)
//             : '--';
//     }
// }
